export function TableRowContent({ color, name, group }) {
  return `<tr>
      <td>
        <div style="
            background: ${color};
            border-radius: 50%;
            width: 6px;
            height: 6px;
            display: inline-block;
          "></div>
        ${name}
      </td>
      ${group
        .map(
          ({
            value,
            percentage = "",
          }) => `<td style="text-align: right; padding-left: 6px;">${value}</td>
      <td style="text-align: right; padding-left: 4px;">
        <b>${percentage}</b>
      </td>`
        )
        .join("")}
      
    </tr>`;
}
